export default __webpack_public_path__ + "static/media/home-period.b7cff0a0.mp4";